export default {
  dueDate: {
    en: 'Due Date',
    ar: 'تاريخ الاستحقاق',
  },
  assigned: {
    en: 'Unlocked',
    ar: 'مفتوح',
  },
  classAverage: {
    en: 'Class Average',
    ar: 'معدل الصف',
  },
  submitted: {
    en: 'Submitted',
    ar: 'تم التسليم',
  },
  evaluated: {
    en: 'Evaluated',
    ar: 'تم التقييم',
  },
  pendingReturn: {
    en: 'To Be Returned',
    ar: 'لم يتم إرجاعه بعد',
  },
  pending: {
    en: 'Pending',
    ar: 'قيد الانتظار',
  },
  returned: {
    en: 'Returned',
    ar: 'تم الارجاع',
  },
  maxGrade: {
    en: 'Max Grade',
    ar: 'الدرجة القصوى',
  },
  return: {
    en: 'Return',
    ar: 'إرجاع',
  },
  returnPromptText: {
    en: 'Are you sure you want to return the grade/feedback to the student(s)?',
    ar: 'هل أنت متأكد من إعادة الدرجة / التغذية الراجعة إلى الطالب (الطلبة)؟',
  },
  student: {
    en: 'Student',
    ar: 'لالطالب',
  },
  submittedDate: {
    en: 'Submitted Date',
    ar: 'تاريخ التسليم',
  },
  grade: {
    en: 'Grade',
    ar: 'الدرجة',
  },
  feedback: {
    en: 'Feedback',
    ar: 'التغذية الراجعة',
  },
  returnedDate: {
    en: 'Returned Date',
    ar: 'تاريخ الاسترجاع',
  },
  assignment: {
    en: 'Assignment',
    ar: 'المهمة',
  },
  view: {
    en: 'View',
    ar: 'معاينة',
  },
  pendingSubmission: {
    en: 'Pending Submission',
    ar: 'في انتظار التسليم',
  },
  pendingEvaluation: {
    en: 'Pending Evaluation',
    ar: 'التقييم قيد الانتظار',
  },
  returnAll: {
    en: 'Return All',
    ar: 'إرجاع الكل',
  },
  evaluatedDate: {
    en: 'Evaluated Date',
    ar: 'تاريخ التقييم',
  },
  viewFile: {
    en: 'View file',
    ar: 'عرض الملف',
  },
  assign: {
    en: 'Unlock',
    ar: 'فتح',
  },
  assignAll: {
    en: 'Unlock All',
    ar: 'فتح للجميع',
  },
  unAssign: {
    en: 'Lock',
    ar: 'إغلاق',
  },
  unAssigned: {
    en: 'Locked',
    ar: 'مغلق',
  },
  unAssignAll: {
    en: 'Lock All',
    ar: 'إغلاق للجميع',
  },
  goToStudentSubmission: {
    en: 'Click here to go to Student Submission',
    ar: 'انقر هنا للذهاب إلى تقديم الطلبة',
  },
  studentsLeftTheClass: {
    en: 'Students have left the class',
    ar: 'عدد الطلبة الذين غادروا الصف',
  },
  putYourText: {
    en: 'Put your text here',
    ar: 'ضع النص هنا',
  },
  submissionReturn: {
    en: 'Submission Return',
    ar: 'إرجاع التسليم',
  },
  assignmentDescription: {
    en: 'Assignment Description',
    ar: 'وصف المهمه',
  },
  noResults: {
    en: 'No Results to Display',
    ar: 'لا توجد نتائج للعرض',
  },
  lockedStudentByCountSingular: {
    en: 'no_of_students student assignment has been Locked',
    ar: 'تم إغلاق مهمة',
  },
  lockedStudentByCountPlural: {
    en: 'no_of_students student assignments has been Locked',
    ar: 'تم إغلاق  # مهام',
  },
  lockedStudentByName: {
    en: "name_of_the_student's assignment has been Locked",
    ar: 'name_of_the_student تم إغلاق المهام الخاصة ب',
  },
  evaluatedStudentByName: {
    en: "name_of_the_student's assignment has been evaluated",
    ar: 'name_of_the_student تم تقييم المهمة  الخاصة ب',
  },
  unEvaluatedStudentByName: {
    en: 'name_of_the_student’s assignment evaluation has been removed',
    ar: 'تم حذف المهمة الخاصة ب name_of_the_student',
  },
  returnedStudentByCount: {
    en: 'no_of_assignments assignment have been returned',
    ar: 'no_of_assignments تم إرجاع  المهمة الخاصة ب',
  },
  returnedStudentsByCount: {
    en: 'no_of_assignments assignments have been returned',
    ar: 'تم إرجاع مهمة no_of_assignments',
  },
  returnedStudentsByName: {
    en: 'name_of_the_student’s assignment has been Returned',
    ar: 'تم إرجاع  المهمة  الخاصة ب name_of_the_student',
  },
  unlockedStudentByCountSingular: {
    en: 'no_of_students student assignment has been Unlocked',
    ar: 'no_of_students تم فتح المهمة الخاصة ب',
  },
  unlockedStudentByCountPlural: {
    en: 'no_of_students student assignments have been Unlocked',
    ar: 'تم فتح # مهام',
  },
  unlockedStudentByName: {
    en: "name_of_the_student's assignment has been Unlocked.",
    ar: 'name_of_the_student تم فتح المهمة  الخاصة ب',
  },
  assignmentSubmittedErrorModalTitle: {
    en: 'Alert',
    ar: 'تنبيه',
  },
  assignmentSubmittedErrorModalContent: {
    en:
      'An update has been made to one of the student records. Please refresh the page before proceeding.',
    ar: 'تم إجراء تحديث على أحد سجلات الطلاب. يرجى تحديث الصفحة قبل المتابعة',
  },
};
